import { QueryKeys } from '../../../enums/queryKeys'
import { InvoicesQueryProps } from '../types/invoicesQueryProps'

export const getInvoicesQueryKey = (queryProps: InvoicesQueryProps): [QueryKeys, InvoicesQueryProps] => [
  QueryKeys.Invoices,
  queryProps,
]
